module.exports = __webpack_public_path__ + "img/gitlab.png";